import React from "react";
import styled from "styled-components";
import { useAtom } from "jotai";
import { IS_DESKTOP_SCALE} from "../../../AtomStates";
import gyeongwonLogo from "../../../../assets/images/gyunwonlogo.png";
import B_food_1 from "../../../../assets/images/Background/B_food_1.png";
import B_food_2 from "../../../../assets/images/Background/B_food_2.png";
import Info_Background from "../../../../assets/images/Background/Info_background.png";

// 날씨 아이콘 import 추가
import s30Icon from "../../../../assets/images/weather_icon/S30.png";
import s10Icon from "../../../../assets/images/weather_icon/S10.png";
import s40Icon from "../../../../assets/images/weather_icon/S40.png";
import s44Icon from "../../../../assets/images/weather_icon/S44.png";
import s45Icon from "../../../../assets/images/weather_icon/S45.png";
import s46Icon from "../../../../assets/images/weather_icon/S46.png";
import s47Icon from "../../../../assets/images/weather_icon/S47.png";
import s11Icon from "../../../../assets/images/weather_icon/S11.png";
import s12Icon from "../../../../assets/images/weather_icon/S12.png";
import s13Icon from "../../../../assets/images/weather_icon/S13.png";
import s14Icon from "../../../../assets/images/weather_icon/S14.png";
import s15Icon from "../../../../assets/images/weather_icon/S15.png";
import s16Icon from "../../../../assets/images/weather_icon/S16.png";
import s17Icon from "../../../../assets/images/weather_icon/S17.png";
import s31Icon from "../../../../assets/images/weather_icon/S31.png";
import s32Icon from "../../../../assets/images/weather_icon/S32.png";
import s33Icon from "../../../../assets/images/weather_icon/S33.png";
import s34Icon from "../../../../assets/images/weather_icon/S34.png";
import s35Icon from "../../../../assets/images/weather_icon/S35.png";
import s36Icon from "../../../../assets/images/weather_icon/S36.png";
import s37Icon from "../../../../assets/images/weather_icon/S37.png";
import s41Icon from "../../../../assets/images/weather_icon/S41.png";
import s42Icon from "../../../../assets/images/weather_icon/S42.png";
import s43Icon from "../../../../assets/images/weather_icon/S43.png";

const Line687 = ({ isToday = false }) => {
  return <StyledLine isToday={isToday} />;
};



const MoleculeMenuBoard = ({
  backgroundType = "white",
  backgroundImage = null,
  titleData: initialTitleData,
  menuData,
  noticeText,
  rightPanelTitle = "안내",
  rightPanelItems = "추가 정보가 들어갑니다.",
  rightPanelTemp = null,
  clockEnabled = true,
  weatherData, // 추가: 날씨 데이터
  logo
}) => {
  const [isDesktopScale] = useAtom(IS_DESKTOP_SCALE);
  
  // 더미 데이터
    const dummyMenuData = {
        "meal_schedule": [
            {
                "date": "2025-12-01",
                "lunch_menu": [
                    "백미밥",
                    "시락국",
                    "헐랭이수육",
                    "온두부/양념장",
                    "상추쌈/쌈장",
                    "배추김치"
                ],
                "lunch_origins": "돼지고기: 미국산",
                "dinner_menu": [
                    "백미밥",
                    "김치햄짜글이",
                    "고추잡채&꽃빵",
                    "콘샐러드",
                    "오징어젓갈무침",
                    "배추김치"
                ],
                "dinner_origins": "돼지고기: 미국산"
            },
            {
                "date": "2025-11-18",
                "lunch_menu": [
                    "백미밥",
                    "소고기미역국",
                    "소고기숙주볶음",
                    "라따뚜이",
                    "브로컬리버섯숙회",
                    "배추김치"
                ],
                "lunch_origins": "소고기: 호주산",
                "dinner_menu": [
                    "백미밥",
                    "크림스프",
                    "함박스테이크",
                    "미트볼크림파스타",
                    "피클&할리피뇨",
                    "배추김치"
                ],
                "dinner_origins": "소고기, 돼지고기: 국내산"
            },
            {
                "date": "2025-11-19",
                "lunch_menu": [
                    "백미밥",
                    "닭개장",
                    "순대콩나물찜",
                    "연근땅콩조림",
                    "도토리묵/양념장",
                    "배추김치"
                ],
                "lunch_origins": "닭고기: 국내산",
                "dinner_menu": [],
                "dinner_origins": ""
            },
            {
                "date": "2025-11-20",
                "lunch_menu": [
                    "백미밥",
                    "팽이버섯된장국",
                    "마파두부",
                    "비엔나감자볶음",
                    "방아고추전",
                    "배추김치"
                ],
                "lunch_origins": "돼지고기: 미국산",
                "dinner_menu": [
                    "백미밥",
                    "순두부찌개",
                    "탕수육/소스",
                    "감자채전",
                    "고추된장무침",
                    "배추김치"
                ],
                "dinner_origins": "돼지고기: 미국산"
            },
            {
                "date": "2025-11-21",
                "lunch_menu": [
                    "콩나물버섯밥",
                    "얼큰어묵탕",
                    "너비아니파채구이",
                    "사누끼우동볶음",
                    "요구르트",
                    "배추김치"
                ],
                "lunch_origins": "돼지고기: 미국산",
                "dinner_menu": [],
                "dinner_origins": ""
            }
        ]
    

  };
  
  // menuData가 없으면 더미 데이터 사용
  const finalMenuData = menuData || dummyMenuData;

  
  // 날씨 아이콘 매핑 객체
  const weatherIcons = {
    S10: s10Icon,
    S11: s11Icon,
    S12: s12Icon,
    S13: s13Icon,
    S14: s14Icon,
    S15: s15Icon,
    S16: s16Icon,
    S17: s17Icon,
    S30: s30Icon,
    S31: s31Icon,
    S32: s32Icon,
    S33: s33Icon,
    S34: s34Icon,
    S35: s35Icon,
    S36: s36Icon,
    S37: s37Icon,
    S40: s40Icon,
    S41: s41Icon,
    S42: s42Icon,
    S43: s43Icon,
    S44: s44Icon,
    S45: s45Icon,
    S46: s46Icon,
    S47: s47Icon,
  };

  // SKY와 PTY 값을 조합하여 날씨 아이콘 코드 생성
  const getWeatherIconCode = (skyCode, ptyCode) => {
    return `S${skyCode}${ptyCode}`;
  };

  // 아이콘 코드로 실제 아이콘 이미지 가져오기
  const getWeatherIconImage = (iconCode) => {
    return weatherIcons[iconCode] || s30Icon; // 기본값은 S30
  };

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const mondayOfWeek = new Date(today);
  const day = mondayOfWeek.getDay();
  const diff = mondayOfWeek.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is Sunday
  mondayOfWeek.setDate(diff);

  // 알레르기 정보 매핑 (finalMenuData에서 allergy_legend 사용)
  const allergyMapping = finalMenuData?.allergy_legend || {};

  // noticeText 설정 (origins 정보 사용)
  const finalNoticeText = finalMenuData?.origins || noticeText || "급식 원산지 정보가 없습니다.";

  // 메뉴 데이터 처리 (meal_schedule 사용)
  const mealSchedule = finalMenuData?.meal_schedule || [];
  const allProcessedMenuData = (Array.isArray(mealSchedule) ? mealSchedule : [])
    .map((item) => {
      if (!item.date) return null;
      const date = new Date(item.date);
      date.setHours(0, 0, 0, 0);
      
      // day_menu가 없거나, 빈 배열인 경우 체크
      const hasValidMenu = item.day_menu && 
        Array.isArray(item.day_menu) && 
        item.day_menu.length > 0;
      
      // 메뉴 아이템들을 문자열로 변환 (name만 추출)
      const menuItems = hasValidMenu 
        ? item.day_menu.map(menuItem => menuItem.name || menuItem).join("\n")
        : "식단 정보가 없습니다.";
      
      return {
        dateObj: date,
        date: `${date.getMonth() + 1}/${date.getDate()}`,
        label: item.day_name || "",
        items: menuItems,
        opacity: today.getTime() === date.getTime() ? 1 : 0.6,
        originalDayMenu: item.day_menu || []
      };
    })
    .filter(Boolean);

  const weekDates = [];
  for (let i = 0; i < 5; i++) {
    const nextDay = new Date(mondayOfWeek);
    nextDay.setDate(mondayOfWeek.getDate() + i);
    weekDates.push(nextDay);
  }

  // designConcept에 따른 이미지 반환 함수
  const getDesignConceptImage = (conceptId) => {
    // console.log("🚀 ~ getDesignConceptImage ~ conceptId:", conceptId);

    switch (conceptId) {
      case "healthy":
        return B_food_1;
      case "happy":
        return B_food_2;
      case "B_food_1":
        return B_food_1;
      case "B_food_2":
        return B_food_2;
      default:
        return Info_Background;
    }
  };

  // 요일/날짜 포맷: "8월 20일 수"
      const daysKOR = ["일", "월", "화", "수", "목", "금", "토"];
      const formatKoreanDateForHeader = (date) => {
        const m = date.getMonth() + 1;
        const d = date.getDate();
        const wd = daysKOR[date.getDay()];
        return `${m}월 ${d}일 (${wd})`;
};

// "(...)" 괄호 보정
      const normalizeParenTag = (s) => {
        const t = (s || "").trim();
        if (!t) return null;
        return t.startsWith("(") ? t : `(${t})`;
};


  const processedMenuData = weekDates.map((weekDate) => {
    const menuItem = allProcessedMenuData.find(
      (item) => item.dateObj.getTime() === weekDate.getTime()
    );
    if (menuItem) {
      return menuItem;
    }
    return {
      dateObj: weekDate,
      date: `${weekDate.getMonth() + 1}/${weekDate.getDate()}`,
      label: "",
      items: "급식 정보가 없습니다.",
      opacity: today.getTime() === weekDate.getTime() ? 1 : 0.6,
    };
  });

  // const weekDays = ["월", "화", "수", "목", "금"];

  // const titleData = initialTitleData || {
  //   title: "주간 식단",
  //   date: new Date()
  //     .toLocaleDateString("ko-KR", {
  //       year: "numeric",
  //       month: "2-digit",
  //       day: "2-digit",
  //     })
  //     .replace(/\. /g, ".")
  //     .slice(0, -1),
  // };

  // 오늘 헤더 날짜
      const headerDate = formatKoreanDateForHeader(today);

// 오늘 메뉴 라벨 및 수요일 태그
      const todayMenuItem = processedMenuData.find(
        (m) => m.dateObj.getTime() === today.getTime()
);

      const apiLabel = normalizeParenTag(todayMenuItem?.label);
      const headerTags = [apiLabel].filter(Boolean);

      const labelShownInHeader = !!normalizeParenTag(todayMenuItem?.label);


      // 오늘 데이터 (없으면 fallback)
      const todayMenu =
      processedMenuData.find(m => m.dateObj.getTime() === today.getTime()) ||
{
        dateObj: new Date(),
        date: `${today.getMonth() + 1}/${today.getDate()}`,
        label: "",
        items: "급식 정보가 없습니다.",
        opacity: 1,
};

// ===== 우측 패널용: 오늘 메뉴의 각 줄에 대응하는 알레르기 이름 라인 생성 =====

// 메뉴 한 줄에서 "1, 6, 18" 같은 숫자만 뽑는 헬퍼 (예: "비빔밥 (1,6)" 또는 "[1, 6]" 등)
const extractAllergenNumbers = (line) => {
  if (!line) return [];
  const nums = Array.from(line.matchAll(/\b(1[0-8]|[1-9])\b/g)).map(m => Number(m[0]));
  // 1~18 범위만 유효
  return nums.filter(n => n >= 1 && n <= 18);
};

// 번호 배열을 이름으로 변환 (정렬·중복제거)
const numbersToNames = (nums) => {
  const unique = Array.from(new Set(nums)).sort((a, b) => a - b);
  return unique.map(n => allergyMapping[n]).filter(Boolean).join(", ");
};

// 원본 menuData에서 '오늘' 객체 찾기
const findTodaySource = () => {
  if (!Array.isArray(mealSchedule)) return null;
  const t = new Date(today); t.setHours(0,0,0,0);
  return mealSchedule.find(it => {
    if (!it?.date) return false;
    const d = new Date(it.date); d.setHours(0,0,0,0);
    return d.getTime() === t.getTime();
  }) || null;
};

const todaySource = findTodaySource();

// 좌측에 표시되는 "오늘 메뉴 줄들"
const leftLines = (todayMenu.items || "").split("\n");

// 우측에 표시할 "알레르기 이름 줄들" 만들기
const allergyNameLines = leftLines.map((_, idx) => {
  // todaySource의 day_menu에서 해당 인덱스의 allergy_numbers 가져오기
  const menuItem = todaySource?.day_menu?.[idx];
  const allergyNumbers = menuItem?.allergy_numbers || [];
  
  // 숫자 배열을 알레르기 이름으로 변환
  const names = numbersToNames(allergyNumbers.map(Number));
  return names || "";
});

// 최종: 우측 패널에 넣을 멀티라인 텍스트
const rightPanelItemsComputed = allergyNameLines.join("\n");

// 우측 패널 메타(시각/온도)
const [now, setNow] = React.useState(new Date());
React.useEffect(() => {
  if (!clockEnabled) return;
  const id = setInterval(() => setNow(new Date()), 60_000); // 1분마다 갱신
  return () => clearInterval(id);
}, [clockEnabled]);

const timeText = React.useMemo(() => {
  if (!clockEnabled) return null;
  // "오전 09:05" 형태
  return now.toLocaleTimeString("ko-KR", { hour: "2-digit", minute: "2-digit" });
}, [now, clockEnabled]);

const tempText = rightPanelTemp == null ? null : `${rightPanelTemp}℃`;

// 날씨 정보 (온도는 rightPanelTemp 또는 weatherData.temperature 사용)
const displayTemp = rightPanelTemp ?? (weatherData?.temperature ? parseFloat(weatherData.temperature) : null);
  const weatherIconElement = React.useMemo(() => {
  if (weatherData && weatherData.sky && weatherData.pty) {
    // API 데이터가 있으면 정확한 아이콘 사용
    return (
      <WeatherIconImg 
        src={getWeatherIconImage(getWeatherIconCode(weatherData.sky, weatherData.pty))} 
        alt="날씨" 
      />
    );
  }
  // 날씨 데이터가 없으면 아이콘 표시하지 않음
  return null;
}, [weatherData]);

const finalTempText = displayTemp !== null ? `${displayTemp}°` : "—°";

const showWeeklyView = false; // 이 값을 true로 바꾸면 주간 식단표가 표시됩니다.

// Timezone 문제를 피하기 위해 YYYY-MM-DD 형식으로 직접 생성
const todayString = today.getFullYear() + '-' +
                  String(today.getMonth() + 1).padStart(2, '0') + '-' +
                  String(today.getDate()).padStart(2, '0');


const todaysMeal = mealSchedule.find(day => day.date === todayString);

const lunchDisplay = 
  todaysMeal?.lunch_menu?.length > 0
    ? todaysMeal.lunch_menu.join('\n')
    : '급식 정보가 없습니다.';

const dinnerDisplay =
  todaysMeal?.dinner_menu?.length > 0
    ? todaysMeal.dinner_menu.join('\n')
    : '급식 정보가 없습니다.';
// 원산지 값 (없으면 빈 문자열)
const lunchOrigins = todaysMeal?.lunch_origins || "";
const dinnerOrigins = todaysMeal?.dinner_origins || "";
  return (
    <StyledContainer
      backgroundType={backgroundType}
      backgroundImage={getDesignConceptImage(backgroundImage)}
      isDesktopScale={isDesktopScale}
    >
      {/* 로고 영역 */}
      <TopSection>

      {/* 타이틀 영역 */}
      {/* 타이틀 영역 - "주간 식단" 제거, 날짜 + 태그만 표시 */}
      <TitleSection>
        <HeaderDate>{headerDate}</HeaderDate>
        {headerTags.map((t, i) => (
          <HeaderTag key={i}>{t}</HeaderTag>
        ))}
      </TitleSection>
      </TopSection>


      {/* 메인 콘텐츠 영역 */}
      <ContentSection>
      <LogoSection>
        <LogoImage src={logo || gyeongwonLogo} alt="경원중학교 로고" />
      </LogoSection>
      {showWeeklyView ? (
      <TwoCol>
      <WeeklyMenuContainer>
        <MenuHeader>
          <MenuTitle>주간 식단표</MenuTitle>
        </MenuHeader>
        
        <MenuTable>
          <thead>
            <tr>
              <th>구분</th>
              {mealSchedule.map((day) => (
                <th key={day.date}>
                  <DayDate>{day.date.split('-').slice(1).join('월 ')}</DayDate>
                  <DayOfWeek>{getDayOfWeek(day.date)}</DayOfWeek>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="category">중식</td>
              {mealSchedule.map((day) => (
                <td key={`lunch-${day.date}`}>
                  {day.lunch_menu && day.lunch_menu.map((item, index) => (
                    <MenuItem key={index}>{item}</MenuItem>
                  ))}
                </td>
              ))}
            </tr>
            
            <tr>
              <td className="origin">원산지</td>
              {mealSchedule.map((day) => (
                <td key={`lunch-origin-${day.date}`} className="origin-cell">
                  {day.lunch_origins}
                </td>
              ))}
            </tr> 
            
            
            <tr>
              <td className="category">석식</td>
              {mealSchedule.map((day) => (
                <td key={`dinner-${day.date}`}>
                  {day.dinner_menu && day.dinner_menu.map((item, index) => (
                    <MenuItem key={index}>{item}</MenuItem>
                  ))}
                </td>
              ))}
            </tr>
            
            <tr>
                <td className="origin">원산지</td>
                {mealSchedule.map((day) => (
                  <td key={`dinner-origin-${day.date}`} className="origin-cell">
                    {day.dinner_origins}
                  </td>
                ))}
              </tr>
    </tbody>
        </MenuTable>
      </WeeklyMenuContainer>
    </TwoCol> 
    ) : (
        <TwoCol>
          <CombinedMenuContainer>
            <ColumnHalf>
              <MenuDate>중식</MenuDate>
              <Line687 />
              <MenuDateSection>
                {!labelShownInHeader && todayMenu.label && (
                  <MenuLabel isToday>{todayMenu.label}</MenuLabel>
                )}
              </MenuDateSection>
              <MenuItems isToday>{lunchDisplay}</MenuItems>
              {lunchOrigins && <OriginText>원산지: {lunchOrigins}</OriginText>}
            </ColumnHalf>
            <ColumnHalf>
              <MenuDate>석식</MenuDate>
              <Line687 />
              <MenuDateSection>
                {/* <RightMeta>
                  {weatherIconElement}
                  {timeText && <MetaChip>{timeText}</MetaChip>}
                </RightMeta> */}
              </MenuDateSection>
              <MenuItems2>
                {dinnerDisplay}
                {dinnerOrigins && <OriginText>원산지: {dinnerOrigins}</OriginText>}
              </MenuItems2>
            </ColumnHalf>
          </CombinedMenuContainer>
        </TwoCol>
    )}
      </ContentSection>
    </StyledContainer>
  );
};

// 스타일 컴포넌트들
const StyledContainer = styled.div`
  width: 3840px;
  height: 2160px;
  position: relative;
  display: flex;
  flex-direction: column;
  
`;

const TopSection = styled.div`
  width: 3750px;
  height: 300px;
  padding: 0px 0px 0px 0px;
  box-sizing: border-box;
  align-items: center;
  position: relative;
  overflow: hidden;
`;

// const LogoSection = styled.div`
//   position: absolute;
//   top: 60px;
//   width: 500px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   justify-self: end;
// `;

// const LogoImage = styled.img`
//   max-width: 100%;
//   max-height: 100%;
//   min-width: 400px;
//   min-height: 90px;
//   object-fit: contain;
// `;

const LogoSection = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 50%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.2;
  z-index: 0;
  pointer-events: none;
`;


const LogoImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: contain;
`;

const TitleSection = styled.div`
  position: absolute;
  left: 92px;
  top: 40px;
  display: flex;
  align-items: flex-end;
  gap: 32px;
`;

const MainTitle = styled.span`
  color: #323232;
  font-size: 112px;
  font-family: Pretendard;
  font-weight: 700;
  line-height: 151.2px;
`;

const DateText = styled.span`
  color: #323232;
  font-size: 88px;
  font-family: Pretendard;
  font-weight: 400;
  line-height: 118.8px;
`;

const ContentSection = styled.div`
  position: absolute;
  left: 92px;
  top: 215px;
  width: 3656px;
  display: flex;
  flex-direction: column;
  gap: 64px;
`;

const MenuContainer = styled.div`
  padding: 88px 88px;
  height: 1588px;
  width: 1046px;
  background: rgba(255, 255, 255, 0.5);
  box-shadow: 0px 4px 32px rgba(0, 0, 0, 0.12);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const MenuContainer2 = styled.div`
  padding: 88px 88px;
  height: 1588px;
  width: 2530px;
  background: rgba(255, 255, 255, 0.5);
  box-shadow: 0px 4px 32px rgba(0, 0, 0, 0.12);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const RightMeta = styled.div`
  margin-left: auto;           /* 같은 줄 오른쪽 정렬 */
  display: flex;
  align-items: center;
  gap: 16px;
`;

const MetaChip = styled.span`
  padding: 8px 20px;
  border-radius: 12px;
  background: none;
  color: #323232;
  font-size: 64px;             /* 상단 타이틀 대비 살짝 작게 */
  font-family: Pretendard;
  font-weight: 500;
  line-height: 1;
`;

const WeekDaysHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 56px;
  padding: 2px 0;
`;

const WeekDay = styled.span`
  color: #323232;
  font-size: 88px;
  font-family: Pretendard;
  font-weight: ${(props) => (props.isToday ? 600 : 400)};
  line-height: 105.6px;
  flex: 1;
  text-align: start;
  opacity: ${(props) => props.opacity || 1};
`;

const MenuGrid = styled.div`
  display: flex;
  gap: 56px;
`;

const MenuColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 88px;
  opacity: ${(props) => props.opacity || 1};
  padding-bottom: 40px;
`;

const MenuDateSection = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

const MenuDate = styled.span`
  color: #323232;
  font-size: 88px;
  font-family: Pretendard;
  font-weight: ${(props) => (props.isToday ? 700 : 600)};
  line-height: 115.2px;
  // text-align: start;
  text-align: center;

  @media (max-aspect-ratio: 1/1) {
  font-size: 140px; /* 세로 모드에서 훨씬 크게 */
  }
`;

const MenuLabel = styled.span`
  color: #323232;
  font-size: 64px;
  font-family: Pretendard;
  font-weight: ${(props) => (props.isToday ? 800 : 700)};
  line-height: 76.8px;
`;

const MenuItems = styled.div`
  color: #323232;
  font-size: 76px;
  font-family: Pretendard;
  font-weight: ${(props) => (props.isToday ? 500 : 400)};
  line-height: 90px;
  white-space: pre-line;
  text-align: start;
  line-height: 1.8;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

   @media (max-aspect-ratio: 1/1) {
    font-size: 120px; /* 세로 모드에서 훨씬 크게 */
    line-height: 1.8;
    font-weight: 700;

  }
`;

const MenuItems2 = styled.div`
  color: #323232;
  font-size: 76px;
  font-family: Pretendard;
  font-weight: ${(props) => (props.isToday ? 500 : 500)};
  line-height: 90px;
  white-space: pre-line;
  text-align: start;
  line-height: 1.8;
   @media (max-aspect-ratio: 1/1) {
    font-size: 120px; /* 세로 모드에서 훨씬 크게 */
    line-height: 1.8;
    font-weight: 700;

    
  }
`;

const OriginText = styled.div`
  color: #666;
  font-size: 50px; /* match InfoBoard's smaller text but scale up appropriately */
  font-family: Pretendard;
  font-weight: 400;
  line-height: 1.2;
  margin-top: 10px;
  white-space: pre-line;
  text-align: start;

  @media (max-aspect-ratio: 1/1) {
    font-size: 100px; /* 세로 모드에서도 너무 크지 않게 */
  }
`;

const NoticeSection = styled.div`
  padding: 40px 72px;
  width: 3656px;
  background: rgba(255, 255, 255, 0.5);
  box-shadow: 0px 8px 64px rgba(0, 0, 0, 0.24);
  border-radius: 24px;
  backdrop-filter: blur(72px);
  display: flex;
  justify-content: start;
  align-items: center;
`;

const NoticeText = styled.span`
  color: #323232;
  font-size: 48px;
  font-family: Pretendard;
  font-weight: 500;
  line-height: 1.5;
  text-align: start;
`;

const StyledLine = styled.div`
  width: 100%;
  height: ${(props) => (props.isToday ? "12" : "8")}px;
  background: #323232;
  margin-bottom: 0px;
`;

const Sudatext = styled.span`
  color: #323232;
  font-size: 64px;
  font-family: Pretendard;
  font-weight: ${(props) => (props.isToday ? 500 : 400)};
  line-height: 96px;
`;


const HeaderDate = styled.span`
  color: #323232;
  font-size: 112px;
  font-family: Pretendard;
  font-weight: 700;
  line-height: 151.2px;
`;

const HeaderTag = styled.span`
  color: #323232;
  font-size: 88px;
  font-family: Pretendard;
  font-weight: 500;
  line-height: 118.8px;
`;

const TwoCol = styled.div`
  width: 3656px;
  display: flex;
  gap: 92px;
  justify-content: space-between;
  
`;

// Combined container that holds two equal halves for lunch and dinner.
const CombinedMenuContainer = styled.div`
  width: 3656px;
  padding: 0;
  height: 1588px;
  background: rgba(255, 255, 255, 0.5);
  box-shadow: 0px 4px 32px rgba(0, 0, 0, 0.12);
  border-radius: 12px;
  display: flex;
  gap: 0px;
  overflow: hidden;
  
  @media (orientation: portrait) {
    flex-direction: column;
    width: 100%;
    height: auto;
  }
`;

const ColumnHalf = styled.div`
  flex: 1;
  padding: 88px 88px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

// 날씨 아이콘 이미지 컴포넌트
const WeatherIconImg = styled.img`
  width: 72px;
  height: 72px;
  object-fit: contain;
`;

const WeeklyMenuContainer = styled.div`
  width: 100%;
  border: 1px solid #000;
  border-radius: 8px;
  overflow: hidden;
`;

const MenuHeader = styled.div`
  background-color: #f5f5f5;
  padding: 16px;
  text-align: center;
  font-weight: bold;
  font-size: 18px;
`;

const MenuTitle = styled.span`
  color: #000;
`;

const MenuTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 0;

  th,
  td {
    padding: 8px;
    text-align: left;
    border: 1px solid #000;
  }

  th {
    /* background-color: #f5f5f5; */
    font-weight: bold;
    text-align: center;
  }

  .category {
    /* background-color: #b8ff78; */
    color: #000;
    font-weight: bold;
    text-align: center;
  }

  .origin {
    /* background-color: #f5c978; */
    color: #000;
    font-weight: bold;
    text-align: center;
  }

  .origin-cell {
    /* background-color: #f5c978; */
    color: #000;
    font-weight: normal;
    text-align: center;
  }
`;

const DayDate = styled.span`
  font-weight: bold;
  font-size: 14px;
`;

const DayOfWeek = styled.span`
  font-size: 12px;
  color: #666;
`;

const MenuItem = styled.div`
  margin: 4px 0;
  font-size: 14px;
`;

const getDayOfWeek = (dateString) => {
  const days = ['일', '월', '화', '수', '목', '금', '토'];
  const date = new Date(dateString);
  return days[date.getDay()];
};

export default MoleculeMenuBoard;
